"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAB_SHOW_TYPE = exports.TAB_TYPE = exports.TAB_THEME = exports.MARKET_MAP = void 0;
const MARKET_MAP = {
    'market1': 'HK',
    'market2': 'MF',
    'market3': 'PF',
    'market4': 'BD',
    'market5': 'US',
    'market6': 'FX',
    'market7': 'SH',
    'market8': 'SZ',
    'market9': 'CN',
    'market10': 'SG',
    'market11': 'JP',
    'market12': 'DE',
    'market13': 'CC',
    'market14': 'TW',
    'market15': 'MY',
    'market16': 'FR',
    'market17': 'NL',
    'market18': 'PT',
    'market19': 'BE',
    'market20': 'GB',
    'market21': 'IT',
    'market22': 'CA',
    'market23': 'AU',
    'market24': 'KR',
    'market25': 'BJ',
    'market26': 'IN',
    'market27': 'SN',
    'market28': 'CFD',
    'market29': 'EC',
    'market30': 'IP',
};
exports.MARKET_MAP = MARKET_MAP;
const TAB_THEME = {
    'DEFAULT': 0,
    'CUSTOM': 1
};
exports.TAB_THEME = TAB_THEME;
const TAB_TYPE = {
    'ENTIRE': 'entire',
    'BELOW': 'below'
};
exports.TAB_TYPE = TAB_TYPE;
const TAB_SHOW_TYPE = {
    'HAS_CONTENT': 0,
    'ONLY_TITLE': 1
};
exports.TAB_SHOW_TYPE = TAB_SHOW_TYPE;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbmYudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsTUFBTSxVQUFVLEdBQUc7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsU0FBUyxFQUFFLElBQUk7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsU0FBUyxFQUFFLElBQUk7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsU0FBUyxFQUFFLElBQUk7SUFDZixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsS0FBSztJQUNqQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtDQUNuQixDQUFDO0FBa0JFLGdDQUFVO0FBaEJkLE1BQU0sU0FBUyxHQUFHO0lBQ2QsU0FBUyxFQUFFLENBQUM7SUFDWixRQUFRLEVBQUUsQ0FBQztDQUNkLENBQUM7QUFjRSw4QkFBUztBQVpiLE1BQU0sUUFBUSxHQUFHO0lBQ2IsUUFBUSxFQUFFLFFBQVE7SUFDbEIsT0FBTyxFQUFFLE9BQU87Q0FDbkIsQ0FBQztBQVVFLDRCQUFRO0FBUlosTUFBTSxhQUFhLEdBQUc7SUFDbEIsYUFBYSxFQUFFLENBQUM7SUFDaEIsWUFBWSxFQUFFLENBQUM7Q0FDbEIsQ0FBQztBQU1FLHNDQUFhIn0=